import { render, staticRenderFns } from "./wmsSiderbar.vue?vue&type=template&id=c92ab826&scoped=true"
import script from "./wmsSiderbar.vue?vue&type=script&lang=ts"
export * from "./wmsSiderbar.vue?vue&type=script&lang=ts"
import style0 from "./wmsSiderbar.vue?vue&type=style&index=0&id=c92ab826&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92ab826",
  null
  
)

export default component.exports